import Ember from 'ember';
import { helper } from '@ember/component/helper';

export function isTesting() {
  return Ember.testing;
}

export default helper(isTesting);
